import { CardContent } from '@/components/ui/card'
import { Slider } from '@/components/ui/slider'
import { CompactToggle, ToggleSetting } from '@/components/ui/toggle-setting'
import PlanCardShell from '@/components/plan/PlanCardShell'
import PlanFieldDelta from '@/components/plan/PlanFieldDelta'

// Nonelective contribution, as its own top-level plan card.
export default function NecCard({
  id,
  title,
  description,
  contributions,
  reference,
  compareTo,
  onNecEnabledChange,
  onNecPercentChange,
  onNecSafeHarborChange,
  disabled,
  variant,
}) {
  const { necEnabled, necPercent, necIsSafeHarbor } = contributions

  return (
    <PlanCardShell
      id={id}
      disabled={disabled}
      variant={variant}
      title={title}
      description={description}
      titleAction={() => onNecEnabledChange(!necEnabled)}
      titleActionLabel="Toggle nonelective contribution"
      titleActionDisabled={disabled}
      headerAction={<CompactToggle label="Include nonelective contribution in plan" checked={necEnabled} onCheckedChange={onNecEnabledChange} disabled={disabled} />}
      collapsible={false}
    >
      {(reference || necEnabled) && <CardContent className="space-y-3">
        {reference}
        {necEnabled && (
          <div className="space-y-3 rounded-md bg-muted/30 p-3">
            <Slider
              validationId={`${id}-nec-rate`}
              validationLabel="NEC rate"
              label={(v) => <>NEC rate<PlanFieldDelta value={v} compareValue={compareTo?.necPercent} show={Boolean(compareTo?.necEnabled)} format="percent" /></>}
              ariaLabel="NEC rate"
              suffix="% of comp"
              value={necPercent}
              onValueCommit={(val) => onNecPercentChange(val[0])}
              min={0}
              max={15}
              step={0.25}
            />
            <ToggleSetting title="Safe harbor (immediate vesting)" description="Safe harbor NEC requires immediate vesting (100% vested)" checked={necIsSafeHarbor} onCheckedChange={onNecSafeHarborChange} />
            <p className="text-xs text-muted-foreground">Common rates: 3% (basic safe harbor), 4% (enhanced)</p>
          </div>
        )}
      </CardContent>}
    </PlanCardShell>
  )
}
